import React from 'react';

// Alert Dialog
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

// Yup
import * as yup from 'yup';

// Formik
import { Form, Formik } from 'formik';

// Mobx
import { inject, observer } from 'mobx-react';

// Helpers
import Helpers from '../helpers';

// Components
import IconButton from './Buttons/IconButton';
import FunctionalTextInput from './Inputs/FunctionalInput';
import FunctionalButton from './Buttons/FunctionalButton';

// Interfaces
interface Features {
    productDetails: any;
    storeId: any;
    ShoppingCartStore?: any;
    StoreStore?: any;
    update?: any;
}

@inject('ShoppingCartStore', 'StoreStore')
@observer

export default class ShoppingCartForm extends React.Component<Features> {
    constructor(props: any) {
        super(props);
    }

    render() {
        const update = this.props.update !== undefined ? true : false;
        const updateData = this.props.update;

        const storeData = this.props.StoreStore.stores[this.props.storeId];

        const initialValues: any = {
            quantity: update ? updateData.quantity : 0,
            storeId: this.props.storeId
        };

        return (
            <Formik
                initialValues={initialValues}
                onSubmit={(values: any, { resetForm }) => {
                    if (update) {
                        Helpers.updateShoppingCart(updateData.id, {
                            ...values,
                            product_id: this.props.productDetails.id
                        }, !update);
                    } else {
                        if (values.quantity !== 0) {
                            Helpers.createShoppingCart({
                                ...values,
                                store_id: this.props.storeId,
                                product_id: this.props.productDetails.id
                            });
                            resetForm(initialValues);
                        }
                    }
                }}
                validationSchema={yup.object().shape({
                    quantity: yup
                        .number()
                        .required(Helpers.translation('cannot_be_left_blank'))
                })}
            >
                {(props: any) => {
                    return (
                        <Form className="w-full">
                            <div className="flex flex-row mt-2 items-center">
                                <IconButton
                                    icon="fa fa-minus"
                                    rounded
                                    customClasses="mr-2"
                                    onPress={() => {
                                        let quantity = props.values.quantity;
                                        if (quantity >= 1) {
                                            quantity = quantity - 1;
                                        }

                                        if (quantity === "") {
                                            quantity = 0;
                                        }

                                        props.setFieldValue("quantity", quantity);

                                        if (update) {
                                            props.handleSubmit();
                                        }
                                    }}
                                />

                                <FunctionalTextInput
                                    name="quantity"
                                    placeholder={Helpers.translation('quantity')}
                                    type="number"
                                />

                                <IconButton
                                    icon="fa fa-plus"
                                    rounded
                                    customClasses="ml-2"
                                    onPress={() => {
                                        let quantity = props.values.quantity;

                                        if (quantity === "") {
                                            quantity = 0;
                                        }
                                        quantity = quantity + 1;

                                        const shoppingCartIndex = Helpers.findIndexByCriteria(Helpers.objectToArray(this.props.ShoppingCartStore.shoppingCarts), "product_id", parseInt(this.props.productDetails.id));

                                        if (shoppingCartIndex !== -1) {
                                            if (update) {
                                                quantity = quantity - updateData.quantity;
                                                quantity = updateData.quantity + quantity;

                                                const nonStockOrder = storeData.non_stock_order ? true : quantity <= Helpers.getProductStock(this.props.productDetails);

                                                if (nonStockOrder) {
                                                    props.setFieldValue("quantity", quantity);

                                                    props.handleSubmit();
                                                } else {
                                                    confirmAlert({
                                                        title: Helpers.translation('error'),
                                                        message: Helpers.translationParams("shopping-cart/shopping-cart-stock-error", { quantity: 0 }),
                                                        buttons: [
                                                            {
                                                                label: Helpers.translation('i-got-it'),
                                                            }
                                                        ]
                                                    });
                                                }
                                            } else {
                                                const shoppingCartData = Helpers.objectToArray(this.props.ShoppingCartStore.shoppingCarts)[shoppingCartIndex];
                                                const newQuantity = quantity + shoppingCartData.quantity;
                                                const availableStockQuantity = Helpers.getProductStock(this.props.productDetails) - shoppingCartData.quantity;

                                                const nonStockOrder = storeData.non_stock_order ? true : newQuantity <= Helpers.getProductStock(this.props.productDetails);

                                                if (nonStockOrder) {
                                                    props.setFieldValue("quantity", quantity);
                                                } else {
                                                    confirmAlert({
                                                        title: Helpers.translation('error'),
                                                        message: Helpers.translationParams("shopping-cart/stock-error", { shoppingCartQuantity: shoppingCartData.quantity, newShoppingCartQuantity: newQuantity, stock: Helpers.getProductStock(this.props.productDetails), availableStockQuantity: availableStockQuantity }),
                                                        buttons: [
                                                            {
                                                                label: Helpers.translation('i-got-it'),
                                                            }
                                                        ]
                                                    });
                                                }
                                            }
                                        } else {
                                            const nonStockOrder = storeData.non_stock_order ? true : quantity <= Helpers.getProductStock(this.props.productDetails);

                                            if (nonStockOrder) {
                                                props.setFieldValue("quantity", quantity);
                                            } else {
                                                confirmAlert({
                                                    title: Helpers.translation('error'),
                                                    message: Helpers.translationParams("shopping-cart/not-shopping-cart-stock-error", { stock: Helpers.getProductStock(this.props.productDetails), availableStock: Helpers.getProductStock(this.props.productDetails) }),
                                                    buttons: [
                                                        {
                                                            label: Helpers.translation('i-got-it'),
                                                        }
                                                    ]
                                                });
                                            }
                                        }
                                    }}
                                />
                            </div>

                            {
                                !update &&
                                <FunctionalButton
                                    text={Helpers.translation('add-shopping-cart')}
                                    fullWidth={false}
                                    textColor="text-white"
                                    rounded
                                    customClasses="mt-4"
                                />
                            }
                        </Form>
                    )
                }
                }
            </Formik>
        )
    }
}